import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, CardActions, CardContent } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import BackgroundPattern from '@public/assets/images/card-bg-logo.png';
import StyledCard from '@ui/pages/Home/components/FullHeightCard/StyledCard';
import { ArrowDown2, ArrowRight, MagicStar, People, Sms, Task } from 'iconsax-react';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import useHomeStyles from './useSuccessPageStyles';
import { PageLayout } from '@ui/components/PageLayout';
import { StyledMenu } from '@ui/components/common/Menu';
import { Icon } from '@iconify/react';
export const SuccessPage = ({ eventTitle, eventId, createdBy, memberType }) => {
    const classes = useHomeStyles();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleOpenMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleCloseMenu = () => {
        setAnchorEl(null);
    };
    const moreMenuActions = [
        {
            text: t('eventSuccess.addTasks'),
            icon: _jsx(Task, { variant: 'Outline', size: 20 }),
            to: () => {
                navigate(`/event-tasks/${eventId}`);
                handleCloseMenu();
            },
            group: true
        },
        {
            text: t('eventSuccess.manageRSVPs'),
            icon: _jsx(People, { variant: 'Outline', size: 20 }),
            to: () => navigate(`/event-details/${eventId}?tab=rsvpTracking`),
            group: true
        },
        {
            text: t('events.createNewEvent.previewEventForm'),
            icon: _jsx(Icon, { icon: 'hugeicons:computer-phone-sync', fontSize: 20 }),
            to: () => navigate(`/event/preview/${eventId}`),
            group: true
        }
    ];
    const getBgPatternStyles = {
        backgroundImage: `url(${BackgroundPattern})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'bottom',
        backgroundSize: 'cover'
    };
    return (_jsx(PageLayout, { title: eventId ? t('events.editEvent') : t('events.newEvent'), showLeftIcon: true, leftIcon: _jsx(MagicStar, { variant: 'Outline', width: 32, height: 32 }), secondTitle: t('events.planYourEvent'), children: _jsx(Box, { sx: classes.main, children: _jsxs(Box, { sx: classes.contentContainer, children: [_jsx(Box, { component: 'img', src: '/assets/images/diamond-sky-speaker.png', alt: 'Sky', sx: {
                            height: '27dvh'
                        } }), _jsx(Typography, { lineHeight: '100%', variant: 'h1', fontWeight: 500, color: 'text.primary', children: t('eventSuccess.title') }), _jsxs(StyledCard, { customVariant: 'light', sx: {
                            ...getBgPatternStyles,
                            minWidth: '268px',
                            maxWidth: '589px',
                            boxShadow: 'none',
                            backgroundColor: 'transparent',
                            backgroundImage: 'none'
                        }, children: [_jsxs(CardContent, { children: [_jsx(Typography, { variant: 'body1', sx: classes.typography, children: _jsx(Trans, { i18nKey: 'eventSuccess.thankYou', components: [
                                                _jsx(React.Fragment, {}),
                                                _jsx(Box, { component: 'span', sx: classes.span }),
                                                _jsx(React.Fragment, {}),
                                                _jsx(Box, { component: 'span', sx: classes.span })
                                            ], values: { name: createdBy, eventName: eventTitle || '' } }) }), _jsx(Typography, { variant: 'body1', mt: 1.5, sx: classes.typography, children: _jsx(Trans, { i18nKey: 'eventSuccess.internalOnly', components: [_jsx(React.Fragment, {}), _jsx(Box, { component: 'span', sx: classes.span })], values: { memberType: memberType } }) }), _jsx(Typography, { variant: 'body1', sx: classes.typography, children: t('eventSuccess.detailsSaved') }), _jsx(Typography, { variant: 'body1', mt: 1.5, sx: classes.typography, children: t('eventSuccess.celebration') })] }), _jsxs(CardActions, { sx: {
                                    mt: 1.5,
                                    flexDirection: { xs: 'column', sm: 'row', gap: 8 },
                                    justifyContent: 'center'
                                }, children: [_jsx(Button, { variant: 'outlined', size: 'large', color: 'primary', sx: { whiteSpace: 'noWrap' }, endIcon: _jsx(ArrowDown2, {}), onClick: handleOpenMenu, children: t('eventSuccess.moreActions') }), _jsx(StyledMenu, { anchorEl: anchorEl, open: open, onClose: handleCloseMenu, anchorOrigin: {
                                            vertical: 'bottom',
                                            horizontal: 'right'
                                        }, transformOrigin: {
                                            vertical: 'top',
                                            horizontal: 'right'
                                        }, actions: moreMenuActions }), _jsx(Button, { variant: 'outlined', size: 'large', endIcon: _jsx(Sms, { variant: 'Outline' }), onClick: () => navigate(`/event-details/${eventId}?tab=rsvpTracking`), children: t('events.createNewEvent.inviteAttendees') }), _jsx(Button, { variant: 'contained', size: 'large', endIcon: _jsx(ArrowRight, {}), onClick: () => navigate(`/event-details/${eventId}`), children: t('eventSuccess.eventDetails') })] })] })] }) }) }));
};
